export default "__VITE_ASSET__Dj_r6wLa__"